import React, { FC } from 'react';
import { Props } from './typings';
import './style.scss';

const TextArea: FC<Props> = (props): JSX.Element => {
  const {
    id,
    customStyleClass,
    textareaWrapperClass,
    name,
    value,
    label,
    isRequired,
    placeholder,
    onBlur = () => {},
    handleChange = () => {},
    maxlength,
    rows,
    cols,
    error,
    errorMessage,
    readonly
  } = props;

  return (
    <div
      className={`form-group ${textareaWrapperClass ?? ''} ${
        error ? 'error-field' : ''
      }`}
    >
       {label && (
        <label>
          {label}
          {isRequired && <em>*</em>}
        </label>
      )}
      <textarea
        id={id}
        placeholder={placeholder}
        className={`form-control ${customStyleClass ?? ''}`}
        name={name}
        value={value}
        onChange={(e) => handleChange(e)}
        onBlur={onBlur}
        rows={rows}
        maxLength={maxlength}
        cols={cols}
        disabled={readonly}
      />
      {error && <span className='error'>{errorMessage}</span>}
    </div>
  );
};

export default TextArea;
